import potkrovlje2i3 from '../assets/img/aprtmani_novo/Potkrovlje 2 i 3 - 1.jpg'
import potkrovlje2i32 from '../assets/img/aprtmani_novo/Potkrovlje 2 i 3 - 2.jpg'
import potkrovlje2i33 from '../assets/img/aprtmani_novo/Potkrovlje 2 i 3 - 3.jpg'
import potkrovlje2i34 from '../assets/img/aprtmani_novo/Potkrovlje 2 i 3 - 4.jpg'

const potkrovlje2 = [
    
    {
        id: 55,
        title: 'Potkrovlje 2, 3-1',
        text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
        size: '40.6',
        image: potkrovlje2i3
    },
    {
        id: 10,
        title: 'Potkrovlje 2, 3-2',
        text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
        size: '39.7',
        image: potkrovlje2i32
    },
    {
        id: 11,
        title: 'Potkrovlje 2, 3-3',
        text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
        size: '27.5',
        image: potkrovlje2i33
    },
    {
        id: 12,
        title: 'Potkrovlje 2, 3-4',
        text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
        size: '27.5',
        image: potkrovlje2i34
    },

    
]

export default potkrovlje2;